import React from 'react';

function About() {
  return (
    <div>
      <h1>About This App</h1>
      <h6>App to search Github Users</h6>
      <p>Version: 1.0.0</p>
    </div>
  )
}

export default About;
